import React from "react";

import Context from "../../../context/Context";
import Toggle from "../../common/Toggle/Toggle";
import * as component from "../../util/component";
import { Topic } from "../../../util/tsUtil";
import TextField from 'calcite-react/TextField';
import { FormControlLabel } from 'calcite-react/Form'
import HelpTip from "../../common/HelpTip/HelpTip";

const CSS = {
  section: "i-form-group i-section",
  formGroup: "i-form-group",
  formGroupHeader: "i-form-group-header",
  formGroupName: "i-form-group-name",
  toggleLabel: "i-toggle-label"
};

export default class OfficeHoteling extends React.Component {

  constructor(props) {
    super(props);
    const officeHoteling = this.props.cfg.getConfigurable("officeHoteling");
    this.state = component.newState({
      enabled: !!officeHoteling.enabled,
      appId: officeHoteling.appId
    });
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  onChangeEnabled = (checked) => {
    const cfg = this.props.cfg;
    this.setState(state => {
      return {
        enabled: checked
      }
    });
    cfg.getConfigurable("officeHoteling").enabled = checked;
    Topic.publish(Topic.ReloadViews, {})
  }

  onTextChange = (e) => {
    const cfg = this.props.cfg
    this.setState({
      appId: e.target.value
    })
    cfg.getConfigurable("officeHoteling").appId = e.target.value
  }

  render() {
    const i18n = Context.instance.i18n;
    const enabled = this.state.enabled;
    const appId = this.state.appId || ""

    return (
      <div className={CSS.section}>

        <div key="header" className={CSS.formGroupHeader}>
          <span className={CSS.formGroupName}
            >{i18n.configurator.officeHoteling.caption}</span>
          <HelpTip text={i18n.more.bookWorkspace.hotelingHelpTip}/>
        </div>

        <div key="enableOfficeHoteling" className={CSS.formGroup}>
          <label id={"cfg-officehoteling-enabled-label"} htmlFor={"cfg-officehoteling-enabled"}
            className={"i-flex-between"}>
            <div className={CSS.toggleLabel}
              >{i18n.configurator.officeHoteling.subCaption}</div>
            <Toggle id={"cfg-officehoteling-enabled"} checked={enabled}
              onChange={this.onChangeEnabled}/>
          </label>
        </div>
        {
          this.state.enabled ? 
          <div className="i-hoteling-appid">
            <div key="header" className={CSS.formGroupHeader}>
              <FormControlLabel 
                className="i-appid-label" 
                htmlFor="office-appid">{i18n.more.bookWorkspace.appId}
              </FormControlLabel>
              <HelpTip text={i18n.more.bookWorkspace.appIdHelpTip}/>
            </div>
            <TextField id="office-appid"  
              placeholder={i18n.more.bookWorkspace.appIdPlaceholder}
              value={appId}
              onChange={this.onTextChange} />
          </div> : null
        }
      </div>
    );

  }


}
